export default __webpack_public_path__ + "static/media/sponsor.c7c02c6f.png";